import type { createWikoRpcApi } from '@wiko/rpc-api';

import { createWikoJsonRpcIntegerOverflowError } from './rpc-integer-overflow-error';

export const DEFAULT_RPC_CONFIG: Partial<NonNullable<Parameters<typeof createWikoRpcApi>[0]>> = {
    defaultCommitment: 'confirmed',
    onIntegerOverflow(request, keyPath, value) {
        throw createWikoJsonRpcIntegerOverflowError(request.methodName, keyPath, value);
    },
};
